(function () {
    "use strict";

    angular.module("app").directive("habilFile", FileUploadDirective);

    FileUploadDirective.$inject = ["base64Service"];
    function FileUploadDirective(base64Service) {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                fileType: "@habilFile"
            },
            link: LinkFileUploadDirective,
        };

        function LinkFileUploadDirective(scope, element, _attr, ngModel) {
            element.bind("change", onChange);

            const nativeElement = element[0];

            function onChange() {
                if (!(nativeElement.files instanceof FileList))
                    return updateModelController(null);
                if (nativeElement.files.length === 0)
                    return updateModelController(null);

                const file = nativeElement.files[0];

                readFile(file, updateModelController);
            }

            function readFile(file, callback) {
                const reader = new FileReader();
                reader.onload = function () {
                    const content = base64Service.convertArrayBufferToBase64String(reader.result);
                    const name = file.name;
                    const attachment = { Name: name, Content: content, TypeCode: scope.fileType };
                    callback(attachment);
                };
                reader.readAsArrayBuffer(file);
            }

            /**
             * Propagates the attachment to the UI and controllers
             * @param {any} attachment The new value bound to ng-model
             */
            function updateModelController(attachment) {
                scope.$apply(function () {
                    ngModel.$setViewValue(attachment);
                    ngModel.$render();
                });
            }
        }
    }
})();